import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { grossFamilyIncomeTypes } from 'const';

export default () => {
  const { t, i18n } = useTranslation('online_booking');
  const grossFamilyIncomeOptions = useMemo(
    () => [
      { value: grossFamilyIncomeTypes.lessThan25000, label: t('fees.gross_family_incomes.less_than_25000') },
      { value: grossFamilyIncomeTypes.between25000And49999, label: t('fees.gross_family_incomes.between_25000_and_49999') },
      { value: grossFamilyIncomeTypes.between50000And84999, label: t('fees.gross_family_incomes.between_50000_and_84,999') },
      { value: grossFamilyIncomeTypes.over85000, label: t('fees.gross_family_incomes.over_85000') },
    ],
    [i18n.language],
  );
  return { data: grossFamilyIncomeOptions };
};
